exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".preview[data-v-cf92e81a] {\n  border: 1px solid lightgrey;\n  border-radius: 5px;\n  padding: 10px;\n}\n#image-preview[data-v-cf92e81a] {\n  max-width: 100%;\n}\n", ""]);

